import { render, staticRenderFns } from "./CKEditor.vue?vue&type=template&id=64c20fe5"
import script from "./CKEditor.vue?vue&type=script&lang=js"
export * from "./CKEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports